import React from "react";
const GroupCalendar = React.lazy(() => import('./GroupCalendar'));

export const groupCalendarConfig = [
    {
        path: '/apps/GroupCalendar',
        element:<GroupCalendar/>,
        roleAccess: ['CALENDAR.USER'],
    },
    {
        path: '/apps/GroupCalendar/addGroupKalendar',
        element:<GroupCalendar/>,
        roleAccess: ['CALENDAR.USER'],
    },
    {
        path: '/apps/GroupCalendar/addEventCalendar',
        element:<GroupCalendar/>,
        roleAccess: ['CALENDAR.USER'],
    },
    {
        path: '/apps/GroupCalendar/addEventCalendar/:id',
        element:<GroupCalendar/>,
        roleAccess: ['CALENDAR.USER'],
    },
    {
        path: '/apps/GroupCalendar/detailEvent/:id',
        element:<GroupCalendar/>,
        roleAccess: ['CALENDAR.USER'],
    },
    {
        path: '/apps/GroupCalendar/detailGrup/:id',
        element:<GroupCalendar/>,
        roleAccess: ['CALENDAR.USER'],
        
    },
    {
        path: '/apps/GroupCalendar/editEvent/:id',
        element:<GroupCalendar/>,
        roleAccess: ['CALENDAR.USER'],
    },
    {
        path: '/apps/GroupCalendar/editGrup/:id',
        element:<GroupCalendar/>,
        roleAccess: ['CALENDAR.USER'],
    }
];